import { createFileRoute } from '@tanstack/react-router'

import { GenericProblemMessage } from '../../../components/organisms/generic-problem-message.tsx'
import { useSettingsRequiredPermissions } from '../../../components/pages/backoffice/partners/settings/settings-configuration.ts'
import { SettingsPage } from '../../../components/pages/backoffice/partners/settings/settings-page.tsx'
import { InviteToLoginPage } from '../../../components/templates/invite-to-login/invite-to-login-page.tsx'
import { PermissionChecker } from '../../../components/templates/permission-checker.tsx'
import { useBackofficeUser, usePermissions } from '../../../lib/use-permissions.ts'

export const Route = createFileRoute('/bo/settings/')({
  component: function Component() {
    const backofficeUser = useBackofficeUser()
    const settingsRequiredPermissions = useSettingsRequiredPermissions()
    const { organization } = usePermissions()
    const isPendingOrganization = organization?.status === 'pending'

    if (!backofficeUser || isPendingOrganization) return <InviteToLoginPage />

    if (backofficeUser.type !== 'partner') {
      return (
        <GenericProblemMessage
          title="Pas encore disponible"
          principalMessage="Cette page n'est pas encore disponible pour les utilisateurs du BO"
          firstSubText="Vous devez être un broker pour accéder à cette page"
          secondSubText="Si vous êtes un broker, contactez-nous"
          onButtonClick={() => {
            history.go(-1)
          }}
          buttonText="Revenir à la page précédente"
        />
      )
    }

    return (
      <PermissionChecker requiredPermissions={[settingsRequiredPermissions]}>
        <SettingsPage />
      </PermissionChecker>
    )
  },
})
